import { Tooltip } from "antd";
import ThermoIcon from "./ThermoIcon";
import { TEMPERATURE_CONSTANT } from "../constant";
import { handleBackgroundColor, handleCheckColor } from "../utils/helpers";
import { DATA_EMPTY } from "@constants/common";

type TCustomTooltipProps = {
  temperature: number | string;
  hour: string;
  changeSwitch: boolean;
  isDefrost: boolean;
  threshold: number;
  isActive: boolean | null;
};

const { TITLE } = TEMPERATURE_CONSTANT;

function CustomTooltip(props: TCustomTooltipProps) {
  const { changeSwitch, temperature, hour, isDefrost, threshold, isActive } =
    props;
  const renderTemperature = () => {
    if (isActive === false) {
      return DATA_EMPTY;
    } else {
      if (temperature === DATA_EMPTY) {
        return TITLE.NONE;
      } else {
        return `${temperature}°C`;
      }
    }
  };

  const styleTemperature = () => {
    if (isActive === false) {
      return {
        color: "var(--color-text-primary)",
        textDecoration: "unset",
      };
    } else {
      if (isDefrost) {
        return {
          color: "var(--color-text-primary)",
          textDecoration: "line-through",
        };
      } else {
        return {
          color: handleCheckColor(threshold),
          textDecoration: "unset",
        };
      }
    }
  };

  return (
    <>
      {changeSwitch ? (
        <span className="temperature-report_time">
          {hour}

          <span
            className={`temperature-report_detail-temperature ${
              isActive === false
                ? "temperature-report_normal"
                : isDefrost
                ? "temperature-report_defrost"
                : handleBackgroundColor(threshold)
            }`}
          >
            {renderTemperature()}
          </span>
        </span>
      ) : (
        <Tooltip
          color="white"
          placement="right"
          overlayClassName="temperature-report_custom-tooltip"
          overlayInnerStyle={{ color: styleTemperature().color }}
          title={() => {
            return (
              <>
                <ThermoIcon color={styleTemperature().color} />
                <p
                  style={{ textDecoration: styleTemperature().textDecoration }}
                >
                  {renderTemperature()}
                </p>
              </>
            );
          }}
        >
          <span style={{ textDecoration: styleTemperature().textDecoration }}>
            {hour}
          </span>
        </Tooltip>
      )}
    </>
  );
}

export default CustomTooltip;
